import { Typography } from '@/components/common';
import { Metrics } from '@/interfaces';
import * as React from 'react';

export interface DonutsProps {
	metricsArray: Metrics[];
	size: number; // Tamaño opcional con valor por defecto
	strokeWidth: number; // Grosor del borde
}

export const DonutChart: React.FC<DonutsProps> = ({
	metricsArray,
	size,
	strokeWidth,
}) => {
	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;

	let startAngle = -90; // Comienza desde la parte superior

	return (
		<div className="flex items-center gap-2">
			{/* SVG Donut Chart */}
			<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
				{/* Fondo gris (para llenar el círculo completo) */}
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					strokeWidth={strokeWidth}
					stroke="#E0E0E0"
					fill="transparent"
				/>

				{/* Renderizar cada segmento de datos */}
				{metricsArray.map(({ percentage, color }, index) => {
					const dashOffset = circumference * ((100 - percentage) / 100);
					const segment = (
						<circle
							key={index}
							cx={size / 2}
							cy={size / 2}
							r={radius}
							strokeWidth={strokeWidth}
							stroke={color}
							fill="transparent"
							strokeDasharray={circumference}
							strokeDashoffset={dashOffset}
							transform={`rotate(${startAngle} ${size / 2} ${size / 2})`}
							strokeLinecap="round"
						/>
					);
					startAngle += (percentage / 100) * 360; // Avanza el ángulo
					return segment;
				})}
			</svg>

			{/* Leyenda */}
			<div className="flex flex-col text-sm font-medium">
				{metricsArray.map(({ title, color, percentage }, index) => (
					<div key={index} className="flex items-center gap-1">
						<span
							className="w-4 h-4 rounded-full"
							style={{ background: color }}
						></span>
						<Typography type="regular-16" className="text-opacity-black">
							{title}: {percentage}%
						</Typography>
					</div>
				))}
			</div>
		</div>
	);
};
